import { RootState } from '@reducers/index';
import { ContactUsMessage } from 'src/types/shared/ContactUsMessages';

export const getContactUsMessages = (state: RootState): Record<number, ContactUsMessage> =>
    state.contactUsMessagesReducer.contactUsMessages;
export const getContactUsMessage = (state: RootState, id: number): ContactUsMessage =>
    state.contactUsMessagesReducer.contactUsMessages[id];
export const getContactUsMessagesIsFetching = (state: RootState): boolean =>
    state.contactUsMessagesReducer.isFetching;
export const getContactUsMessagesFetchError = (state: RootState): string | null =>
    state.contactUsMessagesReducer.fetchError;
export const getContactUsMessagesIsDeleting = (state: RootState): boolean =>
    state.contactUsMessagesReducer.isDeleting;
export const getContactUsMessagesDeleteError = (state: RootState): string | null =>
    state.contactUsMessagesReducer.deleteError;
